import {
  setup_ajax,
  show_login_prompt_if_required,
  add_post_to_feed,
  setup_feed_item_interactions,
  shuffle,
  update_side_feed,
  get_feed_info,
} from "./helpers";
setup_ajax();
setup_feed_item_interactions();

function closeAllTldrs() {
  document.querySelectorAll(".summary-icon-container.active").forEach(function (el) {
    el.classList.remove("active");
    var item = el.closest(".feed-item");
    if (item) {
      var inline = item.querySelector(".summary-inline");
      if (inline) inline.classList.add("hidden");
    }
  });
}

window.toggleTldr = function (el, event) {
  var feedItem = el.closest(".feed-item");
  var inline = feedItem.querySelector(".summary-inline");
  var isActive = el.classList.contains("active");
  closeAllTldrs();
  if (!isActive) {
    el.classList.add("active");
    inline.classList.remove("hidden");
  }
  event.stopPropagation();
};

var follow_template = require("./../templates/small-follow.handlebars");

var latest_id;
var last_post_updated_on;
var last_post_score;
var post_ids = {};
var feed_fetch_in_progress = false;
var feed_view_tracked = false;
var feed_engagement_sent = false;
var feed_start_time = Date.now();

function trackEvent(eventType, feedType, postId, sourceSurface, targetUrl) {
  var payload = { event_type: eventType };
  if (feedType) payload.feed_type = feedType;
  if (postId) payload.post_id = postId;
  if (sourceSurface) payload.source_surface = sourceSurface;
  if (targetUrl) payload.target_url = targetUrl;
  fetch("/api/analytics/track_event", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    keepalive: true,
  }).catch(function () {});
}

function trackFeedView(feedType, sourceSurface) {
  if (feed_view_tracked) return;
  feed_view_tracked = true;
  trackEvent("feed_view", feedType, null, sourceSurface);
}

function check_post_in_feed(post) {
  return post_ids.hasOwnProperty(post.id);
}

function update_feed(feed_info, posts) {
  feed_fetch_in_progress = false;
  for (let index in posts) {
    let post = posts[index];
    if (!check_post_in_feed(post)) {
      post.feed_info = feed_info;
      add_post_to_feed($("#home_feed"), post);
      post_ids[post.id] = true;
    }
  }
}

function set_menu_active_section(feed_info) {
  if (feed_info.feed === "main" && feed_info.sort_by === "top") {
    $('#feed-menu [name="top"]').addClass("is-active");
  } else if (feed_info.feed === "main" && feed_info.sort_by === "new") {
    $('#feed-menu [name="new"]').addClass("is-active");
  } else if (
    feed_info.feed === "user" &&
    feed_info.subcategory === "following" &&
    feed_info.sort_by === "new"
  ) {
    $('#feed-menu [name="following"]').addClass("is-active");
  }
}

function getFeedTypeLabel(feed_info) {
  if (feed_info.feed === "main") return feed_info.sort_by;
  if (feed_info.subcategory === "following") return "following";
  return null;
}

function getSourceSurface(feed_info) {
  var prefix = feed_info.topic ? "topic_" : "feed_";
  if (feed_info.feed === "main" && feed_info.sort_by === "top")
    return prefix + "top";
  if (feed_info.feed === "main" && feed_info.sort_by === "new")
    return prefix + "new";
  if (feed_info.feed === "user" && feed_info.subcategory === "following")
    return "feed_following";
  if (
    feed_info.feed === "user" &&
    (feed_info.subcategory === "published" || feed_info.subcategory === "liked")
  ) {
    return "profile_page";
  }
  return "feed_unknown";
}

function initialize_feed(feed_info) {
  post_ids = {};
  var feedLabel = getFeedTypeLabel(feed_info);
  var sourceSurface = getSourceSurface(feed_info);
  trackFeedView(feedLabel, sourceSurface);
  if (feed_info.feed === "user" && feed_info.subcategory === "following") {
    if (show_login_prompt_if_required("following_feed")) {
      return;
    }
    $.get("/api/posts/following", { topic: feed_info.topic }).done(
      function (posts) {
        $("#home_feed").html("");
        last_post_updated_on = posts[posts.length - 1].updated_on;
        update_feed(feed_info, posts);
      },
    );
  }

  if (feed_info.feed === "main" && feed_info.sort_by === "new") {
    $.get("/api/posts/new", { topic: feed_info.topic }).done(function (posts) {
      $("#home_feed").html("");
      last_post_updated_on = posts[posts.length - 1].updated_on;
      update_feed(feed_info, posts);
    });
  }

  if (feed_info.feed === "main" && feed_info.sort_by === "top") {
    $.get("/api/posts/top", { topic: feed_info.topic }).done(function (posts) {
      $("#home_feed").html("");
      last_post_updated_on = posts[posts.length - 1].updated_on;
      update_feed(feed_info, posts);
    });
  }

  if (feed_info.feed === "user" && feed_info.subcategory === "published") {
    $.get("/api/posts/user", { username: feed_info.username }).done(
      function (posts) {
        $("#home_feed").html("");
        if (posts.length !== 0) {
          last_post_score = posts[posts.length - 1].score;
          update_feed(feed_info, posts);
        }
      },
    );
  }

  if (feed_info.feed === "user" && feed_info.subcategory === "liked") {
    $.get("/api/posts/liked", { username: feed_info.username }).done(
      function (posts) {
        $("#home_feed").html("");
        if (posts.length !== 0) {
          last_post_score = posts[posts.length - 1].score;
          update_feed(feed_info, posts);
        }
      },
    );
  }
}

function initialize_menu_feed(feed_info) {
  post_ids = {};

  const is_new_feed = feed_info.feed === "main" && feed_info.sort_by === "new";
  const is_top_feed = feed_info.feed === "main" && feed_info.sort_by === "top";
  const is_following_feed =
    feed_info.feed === "user" && feed_info.subcategory === "following";

  // if (is_top_feed || is_following_feed) {
  //   $.get("/api/posts/new", { topic: feed_info.topic, limit: 5 }).done(
  //     function (posts) {
  //       if (posts.length === 0) {
  //         return;
  //       }
  //       $("#recent_posts_section").removeClass("hidden");
  //       update_side_feed($("#recent_posts"), posts);
  //     },
  //   );
  // }

  // if (is_new_feed || is_following_feed) {
  //   $.get("/api/posts/top", { topic: feed_info.topic, limit: 5 }).done(
  //     function (posts) {
  //       if (posts.length === 0) {
  //         return;
  //       }
  //       $("#top_posts_section").removeClass("hidden");
  //       update_side_feed($("#top_posts"), posts);
  //     },
  //   );
  // }

  // if (is_new_feed || is_top_feed) {
  //   $.get("/api/posts/following", { topic: feed_info.topic, limit: 5 }).done(
  //     function (posts) {
  //       if (posts.length === 0) {
  //         return;
  //       }
  //       $("#following_posts_section").removeClass("hidden");
  //       update_side_feed($("#following_posts"), posts);
  //     },
  //   );
  // }

  if (is_top_feed || is_new_feed) {
    $.ajax({
      method: "GET",
      url: "/api/users/suggestions",
      data: { limit: 2, topic: feed_info.topic },
      success: function (data) {
        if (data.length === 0) {
          return;
        }
        shuffle(data);
        var count = 0;
        for (let index in data) {
          var user = data[index];
          user["custom_size"] = "is-20";
          const html = follow_template(user);
          $("#right_sidebar_recommended_developers_follow_list").append(html);
          count++;
          if (count == 2) {
            break;
          }
        }
        $("#user_recommendations_section").removeClass("hidden");
      },
    });
  }
}

$(function () {
  const feed_info = get_feed_info();

  set_menu_active_section(feed_info);
  initialize_feed(feed_info);
  initialize_menu_feed(feed_info);

  $(window).scroll(function () {
    if (
      $(window).scrollTop() >=
        $(document).height() - $(window).height() - 2000 &&
      !feed_fetch_in_progress
    ) {
      feed_fetch_in_progress = true;
      if (feed_info.feed === "user" && feed_info.subcategory === "following") {
        $.get("/api/posts/following", {
          last_post_updated_on: last_post_updated_on,
          topic: feed_info.topic,
        }).done(function (posts) {
          last_post_updated_on = posts[posts.length - 1].updated_on;
          update_feed(feed_info, posts);
        });
      }
      if (feed_info.feed === "main" && feed_info.sort_by === "new") {
        $.get("/api/posts/new", {
          last_post_updated_on: last_post_updated_on,
          topic: feed_info.topic,
        }).done(function (posts) {
          last_post_updated_on = posts[posts.length - 1].updated_on;
          update_feed(feed_info, posts);
        });
      }
      if (feed_info.feed === "main" && feed_info.sort_by === "top") {
        $.get("/api/posts/top", {
          last_post_updated_on: last_post_updated_on,
          topic: feed_info.topic,
        }).done(function (posts) {
          last_post_updated_on = posts[posts.length - 1].updated_on;
          update_feed(feed_info, posts);
        });
      }
    }
  });

  $(document).on("click", ".post_link", function () {
    var postId = $(this)
      .closest(".feed-item")
      .find("[data-post-id]")
      .data("post-id");
    var feedInfo = get_feed_info();
    var sourceSurface = getSourceSurface(feedInfo);
    var eventType =
      sourceSurface === "profile_page"
        ? "profile_outbound_click"
        : "link_click";
    trackEvent(
      eventType,
      getFeedTypeLabel(feedInfo),
      postId,
      sourceSurface,
      this.href,
    );
  });

  $("#feed-menu .menu-item").on("click", function (e) {
    e.preventDefault();
    feed_view_tracked = false;

    var new_feed_type = $(this).attr("name");
    if (
      new_feed_type === "following" &&
      show_login_prompt_if_required("following_feed")
    ) {
      return;
    }
    $('#feed-menu [name="new"').removeClass("is-active");
    $('#feed-menu [name="following"').removeClass("is-active");
    $('#feed-menu [name="top"').removeClass("is-active");

    $("#topic-info-header").css("display", "none");

    $("#feed-menu [name=" + new_feed_type + "]").addClass("is-active");
    if (new_feed_type !== "top") {
      history.pushState(
        new_feed_type,
        "diff.blog()",
        "/" + new_feed_type + "/",
      );
    } else {
      history.pushState(new_feed_type, "diff.blog()", "/");
    }
    initialize_feed(get_feed_info());
  });

  // Close tldr summaries when clicking outside
  document.addEventListener("click", function () {
    closeAllTldrs();
  });

  // Feed time-on-page tracking
  function sendFeedEngagement() {
    if (feed_engagement_sent) return;
    var seconds = Math.round((Date.now() - feed_start_time) / 1000);
    if (seconds < 10) return;
    feed_engagement_sent = true;
    var feedInfo = get_feed_info();
    trackEvent("feed_engagement", getFeedTypeLabel(feedInfo), null, "time:" + seconds);
  }

  window.addEventListener("beforeunload", sendFeedEngagement);
  document.addEventListener("visibilitychange", function () {
    if (document.hidden) sendFeedEngagement();
  });
});
